module.exports = __webpack_public_path__ + "img/ico-close.52a1ba09.svg";